<template>
  <div class="activity-allocation-editor">
    <div
      v-for="(row, idx) in value"
      :key="'ar-' + idx"
      class="row align-items-start activity-allocation-row"
    >
      <div :class="showPercent ? 'col-md-7' : 'col-md-12'">
        <a-form-item
          :label="idx === 0 ? $t('menu.activites') : ''"
          :required="idx === 0 && required"
        >
          <a-select
            :value="row.activity"
            show-search
            option-filter-prop="children"
            :placeholder="$t('decaissement.activityPlaceholder')"
            allow-clear
            @change="(v) => onActivityChange(idx, v)"
          >
            <a-select-option
              v-for="a in availableActivities(idx)"
              :key="a._id"
              :value="a._id"
            >
              {{ a.designation }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div v-if="showPercent" class="col-md-4">
        <a-form-item
          :label="idx === 0 ? $t('decaissement.activityPercent') : ''"
        >
          <a-input-number
            :value="row.percent"
            :min="0"
            :max="100"
            :precision="2"
            :disabled="!row.activity"
            style="width: 100%"
            @change="(v) => onPercentChange(idx, v)"
          />
        </a-form-item>
      </div>
      <div v-if="value.length > 1" class="col-md-1 pt-1">
        <a-button
          type="danger"
          icon="delete"
          size="small"
          :aria-label="$t('action.supprimer')"
          @click="removeRow(idx)"
        />
      </div>
    </div>
    <a-button type="dashed" block class="mb-2" icon="plus" @click="addRow">
      {{ $t("decaissement.addActivityAllocation") }}
    </a-button>
  </div>
</template>

<script>
export default {
  name: "ActivityAllocationEditor",
  props: {
    value: {
      type: Array,
      required: true,
    },
    activities: {
      type: Array,
      default: () => [],
    },
    required: {
      type: Boolean,
      default: false,
    },
    /** Show percent inputs when combined allocations need a split (>1 selected items). */
    showPercent: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    availableActivities(idx) {
      const taken = new Set(
        this.value
          .map((r, i) => (i !== idx && r.activity ? r.activity : null))
          .filter(Boolean)
      );
      return (this.activities || []).filter(
        (a) => !taken.has(a._id) || this.value[idx].activity === a._id
      );
    },
    onActivityChange(idx, activityId) {
      const next = this.value.map((r, i) => {
        if (i !== idx) return { ...r };
        return { ...r, activity: activityId };
      });
      this.$emit("input", next);
      this.$emit("structure-change");
    },
    onPercentChange(idx, v) {
      const num = v == null || v === "" ? 0 : Number(v);
      const next = this.value.map((r, i) =>
        i === idx ? { ...r, percent: num } : { ...r }
      );
      this.$emit("input", next);
    },
    addRow() {
      const next = this.value.map((r) => ({ ...r }));
      next.push({ activity: undefined, percent: 0 });
      this.$emit("input", next);
      this.$emit("structure-change");
    },
    removeRow(idx) {
      if (this.value.length <= 1) return;
      const next = this.value
        .filter((_, i) => i !== idx)
        .map((r) => ({ ...r }));
      this.$emit("input", next);
      this.$emit("structure-change");
    },
  },
};
</script>

<style scoped>
.activity-allocation-row {
  margin-bottom: 0;
}
</style>
